const HMGESTAO = () => import('../views/Gestao.vue')
const Partidos = () => import('../views/Partidos.vue')
const Vereador = () => import('../views/Vereadores.vue')
const ConsCom = () => import('../views/Conselhos.vue')
const Legislatura = () => import('../views/Legislatura.vue')
const UAdmin = () => import('../views/UnidadeAdministrativa.vue')
const Comissao = () => import('../views/Comissoes.vue')
const ESTRUTUR = () => import('../views/Estrutura.vue')
const AGENTE = () => import('../views/AgentesPublicos.vue')

export default [
  { name: 'viewGestao', path: '/gestao-admin', component: HMGESTAO, meta: { acl: true } },
  { name: 'viewPartidos', path: '/gestao/partidos', component: Partidos, meta: { acl: true } },
  { name: 'viewAgePol', path: '/gestao/agentes-politicos', component: Vereador, meta: { acl: true } },
  { name: 'viewConsCom', path: '/gestao/conselhos-e-comissoes', component: ConsCom, meta: { acl: true } },
  { name: 'viewMandatos', path: '/gestao/legislaturas', component: Legislatura, meta: { acl: true } },
  { name: 'viewUAdmin', path: '/gestao/unidades-administrativas', component: UAdmin, meta: { acl: true } },
  { name: 'viewComPerm', path: '/gestao/comissoes-permanentes', component: Comissao, meta: { acl: true } },
  { name: 'viewEstrutura', path: '/gestao/estrutura-organizacional', component: ESTRUTUR, meta: { acl: true } },
  { name: 'viewAgePub', path: '/gestao/agente-publico', component: AGENTE, meta: { acl: true } }
]
